import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { TableCell } from '@components/ui/table-template/cells/table-cell';
import { TableTemplateColumnConfig } from '@components/ui/table-template/models/table-template-column-config';
import { DataViewModel } from '@components/ui/table-template/models/data-view-model';
import { DataViewModelValue } from '@components/ui/table-template/models/data-view-model-value';

@Component({
    selector: 'app-table-cell-empty',
    templateUrl: './table-cell-empty.component.html',
    styleUrls: ['./table-cell-empty.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableCellEmptyComponent implements TableCell {
  public readonly value = signal<string>('');

  initialize(column: TableTemplateColumnConfig, _row: DataViewModel, _cell: DataViewModelValue): void {
    this.value.set(column.emptyFallback);
  }
}
